import styled from "styled-components";
import { Spin } from "antd";
export const LoadingContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 16px;
`;
export const LoadingSpinner = styled(Spin) `
  .ant-spin-dot-item {
    background-color: #52c41a;
  }
`;
export const LoadingText = styled.div `
  color: #52c41a;
  font-size: 16px;
  font-weight: 500;
`;
